import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { FAQS } from "../data/content";

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="py-20 md:py-32 bg-ivory">
    <div className="max-w-3xl mx-auto px-5 md:px-8">
      <SectionHeading
        chapter="11"
        overline="Questions"
        title="Frequently Asked Questions"
        center
      />
      <Reveal className="-mt-4 md:-mt-8">
        <Accordion type="single" collapsible className="border-t border-gold/25">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-gold/25">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="text-left font-serif text-lg md:text-xl text-royal-deep hover:text-gold-muted hover:no-underline py-6 transition-colors duration-300"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-answer-${i}`} className="text-base font-light text-charcoal/65 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
